import React, { useState } from 'react';
import Modal from '../components/Modal/Modal';
import AddEntity from '../components/AddEntity/AddEntity';
import ApiManager from '../ApiManager/ApiManager';

const BillingItemFields = [
    { label: 'Name', name: 'name', type: 'text', required: true },
    { label: 'Description', name: 'description', type: 'text', required: true },
    { label: 'Taxable', name: 'taxable', type: 'checkbox', required: true },
    { label: 'Allowed Driver to Add', name: 'allow_driver_to_add', type: 'checkbox', required: true },
];



const NewBillingItem = ({onSuccess}) => {
    const [isModalOpen, setModalOpen] = useState(false);

    const toggleModal = () => {
        setModalOpen(!isModalOpen);
    };

    return (
        <div>
                <button className="custom-button" onClick={toggleModal}>
                    New Billing Item
                </button>
            <Modal isOpen={isModalOpen} onClose={toggleModal}>
                <AddEntity
                    toggleFunction={toggleModal}
                    title="Add Billing Item"
                    formFields={BillingItemFields}
                    apiFunction={ApiManager.addBillingItem}
                    onSuccess={onSuccess}
                />
            </Modal>
        </div>
    );
};

export default NewBillingItem;
